import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
/* 引入全局CSS变量文件 */
import './styles/variables.css';
import { myNotification } from '@/components/Notification/notification.js'
import { install as appEnvInstall } from './utils/environment/uniapp.js';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 安装APP环境工具函数到Vue原型
appEnvInstall(Vue);
// 全局挂载到Vue原型上
Vue.prototype.$myNotify = myNotification

// 动态设置rem基准值
function setRemBase() {
  // 获取视口宽度（电视应用视口宽度=屏幕分辨率宽度）
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth
  // 以1920px（1080P）为基准，计算根元素font-size
  const baseFontSize = (viewportWidth / 1920) * 100
  // 设置根元素font-size
  document.documentElement.style.fontSize = `${baseFontSize}px`
}

// 初始化执行
setRemBase()
// 监听窗口大小变化（电视应用通常无需监听，但若支持窗口缩放可保留）
window.addEventListener('resize', setRemBase)